// This component is the first implementation of YdCollapse before redesigning it.
import cn from 'clsx'
import React, { FC, ReactNode, useState } from 'react'
import s from './YdCollapse.module.css'
import { ChevronRight } from '@components/icons'
import { useSpring, a } from '@react-spring/web'
import useMeasure from 'react-use-measure'
export interface YdCollapseProps {
  title: string
  children: ReactNode
  className?: string
  headerPos?: 'left' | 'center'
  headerStyle?: string
}

const YdCollapse: FC<YdCollapseProps> = (props) => {
  const [isActive, setActive] = useState(false)
  const [ref, { height: viewHeight }] = useMeasure()
  const { title, children, className, headerPos = 'left', headerStyle } = props
  const rootClassName = cn(s.root, className)
  const labelClassName = cn(s.label, { [s.center]: headerPos === 'center' })

  const animProps = useSpring({
    height: isActive ? viewHeight : 0,
    config: { tension: 250, friction: 32, clamp: true, duration: 150 },
    opacity: isActive ? 1 : 0,
  })

  const toggle = () => setActive((x) => !x)

  return (
    <div className={rootClassName}>
      <div className={headerStyle}>
        <div
          className={s.header}
          role="button"
          tabIndex={0}
          aria-expanded={isActive}
          onClick={toggle}
        >
          <span className={labelClassName}>
            {title}
            <ChevronRight className={cn(s.icon, { [s.open]: isActive })} />
          </span>
        </div>
      </div>
      <a.div style={{ overflow: 'hidden', ...animProps }}>
        <div
          ref={ref}
          className={cn(s.content, { 'pr-8': headerPos === 'center' })}
        >
          {children}
        </div>
      </a.div>
    </div>
  )
}

export default React.memo(YdCollapse)
